import { createTheme } from '@mui/material/styles';

// Approximates the Angular Material `indigo-pink` prebuilt theme used today.
// Tune palette/typography here as the design system evolves.
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#3f51b5' }, // indigo 500
    secondary: { main: '#e91e63' }, // pink 500
    background: { default: '#fafafa' },
  },
  typography: {
    fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
  },
});
